import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const signinApi = createAsyncThunk(
  "user/signin",
  async (signinData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/users/signin", signinData);
      return response.data;
    } catch (error) {
      console.error("Signin API error:", error, error?.response?.data?.message);
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "Signin failed");
      }
      return rejectWithValue("Signin failed");
    }
  }
);
